module.exports = __webpack_public_path__ + "static/media/upgrade.61b615b5.svg";